import { emit as serviceBusEmitter } from '@estee/elc-service-bus';

import { isVulcan } from '~utils/isVulcan';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const genericEventEmitter = (eventName: string, payload: any) =>
    document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const eventEmitter = (eventName: string, payload: any) =>
    isVulcan()
        ? genericEventEmitter(eventName, payload)
        : // eslint-disable-next-line @typescript-eslint/no-explicit-any
          serviceBusEmitter(eventName as any, payload);
